<template>
  <div class="picmanagetable">
    <el-table :data="tableData"
              style="width: 100%; padding: 10px 10px 0 10px"
              border>
      <el-table-column prop="createAtMY"
                       label="创建日期"
                       width="130">
        <!-- <template slot-scope="scope">
          <span>{{formatConversion(scope.row.createAt)}}</span>
        </template> -->
      </el-table-column>
      <el-table-column prop="updateAtMY"
                       label="修改日期"
                       width="130">
      </el-table-column>
      <el-table-column prop="status"
                       label="状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 0">
            <el-tag type="info">{{ "草稿" }}</el-tag>
          </div>

          <div v-if="scope.row.status == 1">
            <el-tag type="success">{{ "已发布" }}</el-tag>
          </div>

          <div v-if="scope.row.status == 2">
            <el-tag>{{ "定时发布" }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isRecommend"
                       width="70"
                       label="是否推荐">
        <template slot-scope="scope">
          <div v-if="scope.row.isRecommend == 0">

          </div>

          <div style="text-align:center;"
               v-if="scope.row.isRecommend == 1">
            <img src="@/assets/workflow/jian.png"
                 alt="">
          </div>

        </template>
      </el-table-column>
      <el-table-column width="260"
                       prop="title"
                       label="标题"> </el-table-column>

      <el-table-column prop="picLength"
                       label="图片数">
          <template slot-scope="scope">
            <span @click="seePic(scope)" style="color:#137FFE;cursor: pointer;">{{scope.row.picLength}}</span>
          </template>
      </el-table-column>
      <el-table-column prop="createName"
                       label="发布人"> </el-table-column>

      <el-table-column v-if="powersObj.manageWebsiteInfo"
                       label="操作"
                       width="350">
        <template slot-scope="scope">

          <el-button @click="reCallClick(scope)"
                     v-if="scope.row.status === 1"
                     style="color: #f96900; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-circle-close"></i>撤回</el-button>
          <el-button @click="releaseClick(scope)"
                     v-if="scope.row.status == 0"
                     style="color: #13aa65; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-document-checked"></i>发布</el-button>
          <span v-if="scope.row.status === 0 || scope.row.status === 1"
                style="margin: 0 11px"> | </span>
          <el-button @click="changeClick(scope)"
                     style="color: #185ed3; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-edit-outline"></i>修改</el-button>
          <span style="margin: 0 11px"> | </span>
          <el-button @click="recommendClick(scope)"
                     v-if="scope.row.isRecommend == 0"
                     style="color: #185ed3; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-upload2"></i>推荐</el-button>
          <el-button @click="notRecommendClick(scope)"
                     v-if="scope.row.isRecommend == 1"
                     style="color: #185ed3; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-download"></i>取消推荐</el-button>
          <span style="margin: 0 11px"> | </span>
          <el-button @click="removeClick(scope)"
                     style="color: #ff4545; font-weight: bold; font-size: 13px"
                     type="text"
                     class="btn"
                     size="small"><i style="margin-right: 3px"
               class="el-icon-delete"></i>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
// import { getDate,formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
export default {
  name: "picmanagetable",
  props: {
    tableData: Array,
  },

  data () {
    return {
      powersObj
      // tableData:[
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'52个',
      //     pics:'630张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'人文图片库',
      //     picj:'5个',
      //     pics:'30张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'0个',
      //     pics:'0张',
      //   },
      //   {
      //     date:'2020-4-15',
      //     name:'政务图片库',
      //     picj:'1234个',
      //     pics:'95487张',
      //   },
      // ]
    };
  },
  methods: {
    //修改
    changeClick (scope) {
      this.$emit("changeClick", scope);
    },

    //删除
    removeClick (scope) {
      this.$emit("removeClick", scope);
    },
    //撤回
    reCallClick (scope) {
      this.$emit("reCallClick", scope);
    },
    //发布
    releaseClick (scope) {
      this.$emit("releaseClick", scope);
    },


    //推荐
    recommendClick (scope) {
      this.$emit("recommendClick", scope);
    },
    //取消推荐
    notRecommendClick (scope) {
      this.$emit("notRecommendClick", scope);
    },

    //查看图片
    seePic (scope) {
      this.$emit("seePic", scope);
    },

  },
  created () { },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table {
  width: auto;
}
.btn:hover {
  text-decoration: underline;
}
</style>
